var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29167 3.79199H2.79167C1.87119 3.79199 1.125 4.53818 1.125 5.45866V14.2087C1.125 15.1291 1.87119 15.8753 2.79167 15.8753H3.625M5.29167 3.79199V2.95866C5.29167 2.03818 6.03786 1.29199 6.95833 1.29199H9.04167C9.96214 1.29199 10.7083 2.03818 10.7083 2.95866V3.79199M5.29167 3.79199H10.7083M10.7083 3.79199H13.2083C14.1288 3.79199 14.875 4.53818 14.875 5.45866V14.2087C14.875 15.1291 14.1288 15.8753 13.2083 15.8753H12.375M3.625 15.8753V16.7087M3.625 15.8753H12.375M12.375 15.8753V16.7087M5.29167 7.12533V12.542M10.7083 7.12533V12.542",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitCase);
export default __webpack_public_path__ + "static/media/suit-case.392f34ca1f6572f7ccc195da7b6cb8dc.svg";
export { ForwardRef as ReactComponent };